// return the user data from the session storage
export const getUser = () => {
  const userStr = sessionStorage.getItem("user");
  if (userStr) return JSON.parse(userStr);
  else return null;
};

export const getCompany = () => {
  const companyStr = sessionStorage.getItem("company");
  if (companyStr) return JSON.parse(companyStr);
  else return null;
};

export const getCompanyDB = () => {
  const companyDBStr = sessionStorage.getItem("companyDB");
  if (companyDBStr) return JSON.parse(companyDBStr);
  else return null;
};

// return the token from the session storage
export const getToken = () => {
  return sessionStorage.getItem("token") || null;
};

export const getApprovalState = () => {
  return sessionStorage.getItem("isPayrunApproved") || null;
}

// remove the token and user from the session storage
export const removeUserSession = () => {
  sessionStorage.removeItem("token");
  sessionStorage.removeItem("user");
  sessionStorage.removeItem("company");
  sessionStorage.removeItem("companyDB");
};

// set the token and user from the session storage
export const setUserSession = (token, user, company, companyDB) => {
  sessionStorage.setItem("token", token);
  sessionStorage.setItem("user", JSON.stringify(user));
  sessionStorage.setItem("company", JSON.stringify(company));
  sessionStorage.setItem("companyDB", JSON.stringify(companyDB));
};
